var AddressLineFormat;
(function(AddressLineFormat) {
    AddressLineFormat["streetName_streetNumber"] = "streetName_streetNumber";
    AddressLineFormat["streetNumber_streetName"] = "streetNumber_streetName";
})(AddressLineFormat || (AddressLineFormat = {}));

export { AddressLineFormat };
//# sourceMappingURL=checkout-settings.js.map
